import { Box, Step, StepLabel, Stepper } from '@mui/material'
import type { JSX } from 'react'
import { useCallback, useMemo, useReducer, useState } from 'react'
import { useTranslation } from 'react-i18next'

import PreDownloadCheckStep from '@/pages/fota/create/PreDownloadCheckStep'

import { UpdatesContext, updateReducer } from './reducers'
import SelectUpdatesStep from './SelectUpdatesStep'

export const CreateFotaJob = (): JSX.Element => {
  const { t } = useTranslation(['app'])
  const [updates, updatesDispatch] = useReducer(updateReducer, {})
  const [activeStep, setActiveStep] = useState(0)

  const contextValue = useMemo(() => {
    return { state: updates, dispatch: updatesDispatch }
  }, [updates, updatesDispatch])
  const stepLabels = useMemo(
    () => [
      { name: t('device.fotaJobs.selectDevices') },
      { name: t('device.fotaJobs.startDownloadWithCheck') },
    ],
    [t],
  )
  const handleStepChange = useCallback((step: number) => {
    setActiveStep(step)
  }, [])
  return (
    <UpdatesContext.Provider value={contextValue}>
      <Box
        sx={{ width: '100%', margin: '0', padding: '0' }}
        id={'create fota stepper box'}
      >
        <Stepper activeStep={activeStep} alternativeLabel>
          {stepLabels.map((label) => (
            <Step key={label.name}>
              <StepLabel>{label.name}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Box sx={{ mt: 4, position: 'relative', overflow: 'hidden' }}>
          <Box
            sx={{
              transform: `translateX(-${activeStep * 100}%)`,
              transition: 'transform 0.3s ease-in-out',
              display: 'flex',
            }}
          >
            <Box sx={{ width: '100%', flexShrink: 0 }}>
              <SelectUpdatesStep setActiveStep={handleStepChange} />
            </Box>
            <Box sx={{ width: '100%', flexShrink: 0 }}>
              <PreDownloadCheckStep
                setActiveStep={handleStepChange}
                isActive={activeStep === 1}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </UpdatesContext.Provider>
  )
}
